<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- <h1>商品信息</h1> -->
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label-width
                          prop="item"
                          label="平台商品ID">
              <el-input v-model="form.item"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="title"
                          label="商品标题">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="sku"
                          label="SKU">
              <el-input v-model="form.sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="status"
                          label="平台商品状态">
              <!-- <el-input v-model="form.status"></el-input> -->
              <!-- <el-input v-model="form.item_status"></el-input> -->
              <!-- item_status -->
              <el-select clearable
                         v-model="form.item_status"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in [{'name':'onsale'},{'name':'instock'}]"
                           :key="item.name"
                           :label="item.name"
                           :value="item.name">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label-width prop="category" label="商品分类">
              <el-input v-model="form.category"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="6">
            <el-form-item prop="platform_from"
                          label="平台">
              <el-select clearable
                         v-model="form.platform_from"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in tradefrom"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="profession"
                          label="行业">
              <!-- <el-input v-model="form.profession"></el-input> -->
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="business"
                          label="商家">
              <!-- <el-input v-model="form.business"></el-input> -->
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="store"
                          label="店铺">
              <!-- <el-input v-model="form.store"></el-input> -->
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport"></action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column align="center"
                       header-align="center"
                       prop="item"
                       label="图片">
        <template slot-scope="scope">
          <el-popover placement="right"
                      width="200"
                      trigger="hover">
            <img style="width: 300px; height: 300px;"
                 :src="scope.row.pic_url"
                 alt />
            <img slot="reference"
                 style="width: 50px; height: 50px;"
                 :src="scope.row.pic_url"
                 alt />
          </el-popover>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center"
                       header-align="center"
                       prop="item"
                       label="平台商品ID"></el-table-column> -->
      <el-table-column align="center"
                       header-align="center"
                       prop="title"
                       label="商品标题"
                       min-width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="sku"
                       label="SKU"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="item_status"
                       label="平台商品状态"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="quantity"
                       label="库存数"></el-table-column>
      <!-- <el-table-column  align="center" header-align="center" prop="category" label="商品分类"></el-table-column> -->
      <el-table-column align="center"
                       header-align="center"
                       prop="price"
                       label="市场价"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="platform_from"
                       label="平台"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="profession"
                       label="行业"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="business"
                       label="商家"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="store"
                       label="店铺"></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'

import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
export default {
  mixins: [
    ActionLine,
    SearchMixin,
    getplatlists,
    getptnlists,
    getshoplists,
    gettradestatus,
    gettradefrom,
    handleExport,
  ],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        Desc.itemLists_api,
        this.queryPrdlists
      )
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/item/index.vue